import axiosInstance from "../../utils/axios";

const employees = {
  state: {
    rapeEmployees: [] 
  },
  mutations: {},
  actions: {
    async fetchRapeEmployees() {
      try {
        const { data } = await axiosInstance.get("/employees", {
          params: {
            by_rape: true,
            by_status: true,
            per_page: "all",
          },
        });
        return data;
      } catch (error) {
        console.log("Error en el Fecth de datos");
      }
    },
  },
  getters: {},
};

export default employees;
